import * as React from 'react';

const SuperVisorConversationDetailsPage = React.lazy(() => import('../pages/supervisor/SuperVisorConversationDetailsPage'));

export const SupervisorRoutes = [
    { path: 'supervisor/user-ai-interactions-details', element: <SuperVisorConversationDetailsPage />, name: "User-AI Interaction Details Overview", title: "User-AI Interaction Details Overview" },
    // { title:"Add Customer",path: 'customers/add', element: <AddCustomer /> ,name:"Add Customer"},
    // { title: "Profile", path: 'profile', element: <Profile />, name: "Profile" },
]